module.exports = {
  InputText: {
    PluginName: "User input",
    content_box_name: "Content ",
    fontSize: "Font size",
    answerType: "Answer type",
    Precision: "Allowed error",
    Placeholder: "Enter the expected answer",
    Characters: "Ignore case and special characters",
    General: "Advanced",
    text: "Text",
    number: "Number",
    notCount: "This exercise does not add points",
  },
};
